export const PROVIDER_NAME_MAX_LENGTH = 50;
